export default {
  methods: {
    activeInput(event) {
      event.target.nextElementSibling.focus();
      let activeInputs = document.getElementsByClassName(
        "input_type active"
      );
      Array.prototype.slice.call(activeInputs).forEach(element => {
        if (!element.getElementsByTagName("input")[0].value.trim()) {
          element.classList.remove("active");
        }
      });
      if (!event.target.parentElement.classList.contains("active")) {
        event.target.parentElement.classList.add("active");
      }
    }
  }
};



// WEBPACK FOOTER //
// ./resources/js/mixins/beautifulForm.js